import { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import exportToCSV from "../components/exportToCSV";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export async function loader() {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Response(
      JSON.stringify({
        message: "You must be logged in to access this resource.",
      }),
      { status: 401 }
    );
  }

  const response = await fetch(`${apiUrl}/ct/affiliate-throughput`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-App-Secret": process.env.REACT_APP_APP_SECRET,
    },
  });

  if (!response.ok) {
    throw new Response(
      JSON.stringify({ message: "Could not fetch affiliate links." }),
      { status: response.status }
    );
  }

  const affiliateThroughput = await response.json();
  return affiliateThroughput;
}

export default function AffiliateThroughputManagement() {
  const affiliateThroughput = useLoaderData();

  // Set up filters for affiliate_link and id.
  const [filters, setFilters] = useState({
    affiliate_id: "",
    id: "",
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Filter data based on user input.
  const filteredData = affiliateThroughput.filter((item) =>
    Object.entries(filters).every(([key, value]) => {
      if (!value) return true;
      return String(item[key]).toLowerCase().includes(value.toLowerCase());
    })
  );

  return (
    <div className="affiliate-throughput-container">
      <h1>Affiliate Throughput Management</h1>

      {/* Filters */}
      <div className="filters">
        <label>
          Affiliate Id:
          <input
            type="text"
            name="affiliate_id"
            value={filters.affiliate_id}
            onChange={handleFilterChange}
          />
        </label>
        <label>
          ID:
          <input
            type="text"
            name="id"
            value={filters.id}
            onChange={handleFilterChange}
          />
        </label>
      </div>

      {/* CSV Export */}
      <div className="export-button">
        <button
          onClick={() => exportToCSV(filteredData, "affiliate_throughput.csv")}
          className="export-btn"
        >
          Export CSV
        </button>
      </div>

      {/* Table displaying affiliate links, orders completed, and total amount */}
      <table className="management-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Affiliate ID</th>
            <th>Orders Completed</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.affiliate_id}</td>
              <td>{item.orders_completed}</td>
              <td>{item.total_amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
